/** @jsxRuntime classic */
/** @jsx jsx */
// @ts-check
// @ts-check
/** @jsx jsx */
import {
  Box,
  Button,
  DownloadIcon,
  Flex,
  Text,
} from '@bottlebooks/gatsby-theme-base';
import Container from '@bottlebooks/gatsby-design-system/src/components/Grid/Container';
import Layout from '@bottlebooks/gatsby-theme-event/src/components/Layout';
import { Trans } from '@lingui/macro';
import React from 'react';
import { jsx } from 'theme-ui';
import useAuthentication from '../../../gatsby-plugin-firebase-auth/src/useAuthentication';
import CatalogExportDialog from './CatalogExportDialog';
import LoggedOut from './LoggedOut';
import PersonalHeader from './PersonalHeader';
import PersonalMenu from './PersonalMenu';

export default function PersonalPageLayout({
  locale,
  children,
  collectionId,
  ...rest
}) {
  const { isAuthenticated } = useAuthentication();
  const [exportIsVisible, setExportIsVisible] = React.useState(false);

  if (!isAuthenticated())
    return (
      <Layout locale={locale}>
        <LoggedOut />
      </Layout>
    );
  return (
    <Layout locale={locale}>
      <PersonalHeader>
        <Flex
          // @ts-ignore array alignment isn't typed correctly it seems.
          align={['flex-start', 'center']}
          justify="space-between"
          direction={['column-reverse', 'row']}
          sx={{ marginTop: 3, marginBottom: 1 }}
        >
          <PersonalMenu />
          <Button
            variant="text"
            onClick={() => setExportIsVisible(true)}
            sx={{
              color: 'primary',
              display: 'inline-block',
              marginBottom: [2, 1],
            }}
          >
            <DownloadIcon sx={{ marginRight: 1 }} />
            <Text sx={{ display: 'inline-block' }}>
              <Trans>Download my tasting booklet</Trans>
            </Text>
          </Button>
        </Flex>
      </PersonalHeader>
      <Box sx={{ backgroundColor: 'light' }} {...rest}>
        {children}
      </Box>
      {exportIsVisible && (
        <CatalogExportDialog
          locale={locale}
          collectionId={collectionId}
          onClose={() => setExportIsVisible(false)}
        />
      )}
    </Layout>
  );
}

export const ListContainer = React.forwardRef(function ListContainer(
  { children, ...rest },
  ref
) {
  return (
    <Container
      ref={ref}
      fluid
      sx={{
        maxWidth: 'container.fluid',
        paddingX: [0, 'gutter'],
        paddingBottom: 5,
      }}
      {...rest}
    >
      {children}
    </Container>
  );
});
